require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/maps/Map.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/maps/Map.legacy.js
// module id = 658
// module chunks = 31